<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">* Casino</p>
            <reference
                create-text="Create new casino and link casino to this page"
                link-text="Link an existing casino"
                v-model="form.casino"
                model-data="Casino"
                :should-open-new-window=true
                :query="{
                    'casinoReview.status_id': 1
                }"
                :order="{
                    'casinos.name': 'asc'
                }"
                :language="form.language"
                :error="errors.casino_id ? errors.casino_id[0] : null"
                :deletable="false"
                :creatable="false"
            />
        </div>

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
            v-show="false"
        >
            <p class="text-gray-700 mb-4">Ranking</p>
            <reference
                create-text="Create new ranking and link ranking to this page"
                link-text="Link an existing ranking"
                v-model="form.ranking"
                model-data="Ranking"
                :should-open-new-window=true
                :error="errors.ranking_id ? errors.ranking_id[0] : null"
                :deletable="false"
                :creatable="false"
            />
        </div>

        <p class="mt-4">If you do not select a bonus then the casino's review main bonuses will be used and if you do not enter USPs then defaults will be used from the casino.</p>

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">Bonuses</p>
            <multi-reference
                create-text="Create new bonus and link bonus to this page"
                link-text="Link an existing bonus"
                :creatable="false"
                v-model="form.bonuses"
                model-data="Bonus"
                :should-open-new-window=true
                :language="form.language"
                :query="{
                    casino_id: form.casino_id
                }"
                :pre-filled="{
                    casino: form.casino || null,
                }"
                :order="{
                    'name': 'asc'
                }"
                :error="errors.bonuses ? errors.bonuses[0] : null"
            />
        </div>

        <input-text
            class="mt-3"
            name="usp_1"
            label="USP 1"
            v-model="form.usp_1"
            :error="errors.usp_1 ? errors.usp_1[0] : null"
            :maxlength=255
        />
        <media-reference
            v-model="form.usp_one_icon"
            class="mt-3"
            label="USP 1 Icon"
            :media-types="['Icon']"
        />

        <input-text
            class="mt-3"
            name="usp_2"
            label="USP 2"
            v-model="form.usp_2"
            :error="errors.usp_2 ? errors.usp_2[0] : null"
            :maxlength=255
        />
        <media-reference
            v-model="form.usp_two_icon"
            class="mt-3"
            label="USP 2 Icon"
            :media-types="['Icon']"
        />

        <input-text
            class="mt-3"
            name="usp_3"
            label="USP 3"
            v-model="form.usp_3"
            :error="errors.usp_3 ? errors.usp_3[0] : null"
            :maxlength=255
        />
        <media-reference
            v-model="form.usp_three_icon"
            class="mt-3"
            label="USP 3 Icon"
            :media-types="['Icon']"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "ConversionForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                casino: this.getFormData("casino"),
                casino_id: this.getFormData("casino_id"),
                bonuses: this.getReferenceData("bonuses"),
                ranking: this.getFormData("ranking"),
                ranking_id: this.getFormData("ranking_id"),
                usp_1: this.getFormData("usp_1"),
                usp_2: this.getFormData("usp_2"),
                usp_3: this.getFormData("usp_3"),
                usp_1_icon_id: this.getFormData("usp_1_icon_id"),
                usp_one_icon: this.getFormData("usp_one_icon"),
                usp_2_icon_id: this.getFormData("usp_2_icon_id"),
                usp_two_icon: this.getFormData("usp_two_icon"),
                usp_3_icon_id: this.getFormData("usp_3_icon_id"),
                usp_three_icon: this.getFormData("usp_three_icon"),
            },
        };
    },
    watch: {
        "form.casino": function (newValue) {
            this.form.casino_id = newValue ? newValue.id : null;
        },
        "form.ranking": function (newValue) {
            this.form.ranking_id = newValue ? newValue.id : null;
        },
        "form.usp_one_icon": function (newValue) {
            this.form.usp_1_icon_id = newValue ? newValue.id : null;
        },
        "form.usp_two_icon": function (newValue) {
            this.form.usp_2_icon_id = newValue ? newValue.id : null;
        },
        "form.usp_three_icon": function (newValue) {
            this.form.usp_3_icon_id = newValue ? newValue.id : null;
        },
    },
};
</script>
